import type { Template } from '@ztechapps/common.contract'

export const ShowAllFilterTemplate = { _id: '_show_all_', name: 'Show All', value: '{}' } as unknown as Template
